<template>
  <div class="mall-apply">
    <div class="content">
      <h2>专业工业应用</h2>
      <a href="javascript:;" @click="goAll">查看全部工业应用 ></a>
      <div class="list-box">
        <div
          class="card"
          v-for="el in applyList"
          :key="el.id"
          @click="toService(el)"
        >
          <VImg class="logo" :attachment-id="el.serviceCover" />
          <div class="card-content">
            <div class="top">
              <div class="title">{{ el.serviceName }}</div>
              <p class="text-overflow">{{ el.summary }}</p>
            </div>
            <div v-if="el.pricingType === 1" class="price">
              ￥{{ el.lowestPrice
              }}<span>/{{ el.buyType | buyTypeDict("BUY_TYPE") }}</span>
            </div>
            <div class="price" v-else>议价定制</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VImg from "@/components/VImg.vue";
import { getServicePageList } from "@/api/service.js";

export default {
  name: "mallApply",
  components: { VImg },
  data() {
    return {
      applyList: [],
    };
  },
  methods: {
    goAll() {
      this.$router.push("/service?isService=0");
    },
    toService(el) {
      this.$router.push(`/service/details?id=${el.id}`);
    },
  },
  mounted() {
    getServicePageList({ current: 1, size: 3 }, { isService: 0 }).then(
      (res) => {
        this.applyList = res.records;
        console.log(this.applyList, "this.applyList--");
      }
    );
  },
};
</script>

<style scoped lang="scss">
.mall-apply {
  background: #ffffff;

  .content {
    width: 1280px;
    margin: 0 auto;
    padding: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;

    > h2 {
      font-weight: 600;
      font-size: 32px;
      color: #262626;
      line-height: 45px;
      margin-bottom: 16px;
    }

    > a {
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
    }

    > .list-box {
      margin-top: 48px;
      width: 1280px;
      display: flex;
      flex-wrap: wrap;

      > .card {
        width: 410px;
        height: 156px;
        border: 1px solid #e8e8e8;
        padding: 24px;
        display: flex;
        cursor: pointer;

        .logo {
          display: block;
          width: 56px;
          height: 56px;
          margin-right: 16px;
        }

        .card-content {
          width: 290px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .top {
            padding-top: 4px;

            .title {
              font-weight: 400;
              font-size: 16px;
              color: #262600;
              line-height: 24px;
              margin-bottom: 8px;
            }

            > p {
              font-weight: 400;
              font-size: 12px;
              color: #8c8c8c;
              line-height: 16px;
            }
          }

          .price {
            font-weight: 400;
            font-size: 18px;
            color: #ea0b06;
            line-height: 24px;

            > span {
              font-weight: 400;
              font-size: 12px;
              color: #8c8c8c;
              line-height: 17px;
              margin-left: 4px;
            }
          }
        }
      }

      > :not(:nth-child(3n)) {
        margin-right: 25px;
      }

      > :not(:nth-child(-n + 3)) {
        margin-top: 24px;
      }
    }
  }
}
</style>
